import { z } from 'zod';
import { MonthArray } from './common.js';
export const Goal = z.object({
    id: z.number().int(),
    name: z.string().min(1).max(160),
    target_amount: z.number().int().nullable(),
    amounts: MonthArray,
    sort_order: z.number().int(),
});
export const CreateGoalRequest = z.object({
    name: z.string().min(1).max(160),
    target: z.number().int().min(0).nullable().optional(),
    start_amount: z.number().int().min(0).optional(),
});
export const UpdateGoalRequest = z
    .object({
    name: z.string().min(1).max(160).optional(),
    target: z.number().int().min(0).nullable().optional(),
    amounts: MonthArray.optional(),
    sort_order: z.number().int().optional(),
})
    .refine((v) => Object.keys(v).length > 0, { message: 'no fields provided' });
